import type { PayoutsSession as PayoutsSessionType } from "@whop/embedded-components-vanilla-js/types";

import { useRef } from "react";

export function usePayoutsSessionRef() {
	const ref = useRef<{
		payoutsSession: PayoutsSessionType | null;
	}>(null);
	return ref;
}
